export default __webpack_public_path__ + "static/media/floors.6b776ba3.gltf";